const className = 'js-Product'
const classes = {
  productInfo:'.product__info-container',
  quantityInfo: `.${className}_QuantityInfo`,
  quantityInfoModal: `.${className}_QuantityInfoModal`,
  quantityInfoModalClose: `.${className}_QuantityInfoModalClose`,
  fixedBar: `.${className}_FixedBar`,
  form: `.${className}_Form`,
  loader: `.${className}_Loader`,
  price: `.${className}_Price`,
  priceCompare: `.${className}_PriceCompare`,
  priceWrapper: `.${className}_PriceWrapper`,
  quantity: `.${className}_Quantity`,
  select: `.${className}_Select`,
  singleOptionSelect: `.${className}_SingleOptionSelect`,
  singleOptionButton: `.${className}_SingleOptionButton`,
  variantButton: `.${className}_VariantButton`,
  variantText: `.${className}_VariantText`,
  variantImage: `.${className}_VariantImage`,
  sku: `.${className}_Sku`,
  submit: `.${className}_Submit`,
  delivery: `.${className}_Delivery`,
  deliveryShort: `.${className}_DeliveryShort`,
  deliveryInfo: `.${className}_DeliveryInfo`,
  deliveryModal: `.${className}_DeliveryInfoModal`,
  deliveryModalClose: `.${className}_DeliveryInfoModalClose`,
  nextDayDeliveryInfo: `.${className}_NextDayDeliveryInfo`,
  nextDayDeliveryModal: `.${className}_NextDayDeliveryInfoModal`,
  nextDayDeliveryModalClose: `.${className}_NextDayDeliveryInfoModalClose`,
  QuantityInfoModal:`.${className}_QuantityInfoModal`,
  QuantityInfo:`.${className}_QuantityInfo`,
  QuantityInfoModalClose:`.${className}_QuantityInfoModalClose`,
  disposalInfoTrigger: `.${className}_mattressDisposalCheckbox`,
  mattressDisposalModal:`.${className}_mattressDisposalModal`,
  mattressDisposalModalClose:`.${className}_mattressDisposalModalClose`,
}

// Functions to get the dominant color of an image
let getDominantColor = (img) => {
  let canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  let ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  let imageData = ctx.getImageData(0, 0, img.width, img.height).data;
  let total = [0, 0, 0],count = 0;
  for (let i = 0; i < imageData.length; i += 4) {
    total[0] += imageData[i];
    total[1] += imageData[i + 1];
    total[2] += imageData[i + 2];
    count++;
  }
  let averageColor = [
    Math.round(total[0] / count),
    Math.round(total[1] / count),
    Math.round(total[2] / count)
  ];
  return rgbToHex(averageColor[0], averageColor[1], averageColor[2]);
}
let rgbToHex = (r, g, b) => {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
let componentToHex = (c) => {
  let hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
let isDarkColor = (color) => {
  let rgb = hexToRgb(color);
  let luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
  return luminance < 128;
}
let hexToRgb = (hex) => {
hex = hex.replace(/^#/, '');
let bigint = parseInt(hex, 16),r = (bigint >> 16) & 255,g = (bigint >> 8) & 255,b = bigint & 255;
return { r: r, g: g, b: b };
}
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.secSwatchDrawer = 'swatch-drawer';
        this.saveCurrentProduct();
        this.setupVariantButtons()
        this.initialiseDrawer()
        this.initialiseDetailsDrawer()
        this.initialiseSwatchCards()
        this.productFixedBar()
        this.initialiseAdditionalDetails()
        this.setupMattressDisposal()
        this.setupFinanceCalculator()
        this.setCheckRadio()
        this.setUpsellproduct()
        const path = this.getAttribute('data-url').split('/')
        const handle = path[path.length - 1]
        this.setupDeliveryMessage(handle, false)
        window.addEventListener('popstate', () => {
          const path = window.location.pathname.split('/')
          const handle = path[path.length - 1]

          this.loadProductIntoSection(handle, false)
        })
        let populateProductMedia = false
        const zoomMediaSrc = getElement('#zoom-media-gallery-js').getAttribute('data-src');
        let zoomGallery = 'product-media';
        if(populateProductMedia == false) getElement('#zoom-media-gallery-js').src = zoomMediaSrc;
        addEventListener("mousemove", () => {
          if(populateProductMedia == false) this.populateProductMedia (zoomGallery,handle);
          populateProductMedia = true;
        });
        addEventListener("touchstart", () => {
          if(populateProductMedia == false) this.populateProductMedia (zoomGallery,handle);
          populateProductMedia = true;
        }, { passive: true });
        const pdptitle = this.querySelector('.product__title h1:not(.prd-ProductContent_Category)').innerText;
        this.initialiesGaEvents(pdptitle);
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      saveCurrentProduct() {
        let items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]"),
          currentProductId = this.getAttribute('data-currentProductId'); // We check if the current product already exists, and if it does not, we add it at the start
        if (!items.includes(currentProductId)) items.unshift(currentProductId); // Then, we save the current product into the local storage, by keeping only the 18 most recent
        try {
          localStorage.setItem("recentlyViewedProducts",JSON.stringify(items.slice(0, 18)));
        } catch (error) {
          // Do nothing, this may happen in Safari in incognito mode
        }
      }

      initialiseModals(modal,modalbuttonEl) {
        if(modal == null){return}
        const modalClose = modal.querySelector('[data-el="feature-accordions.modalclose"]');
        modal.addEventListener('click', e => {
          if (e.target !== modal) return
          modal.setAttribute('aria-expanded', false)
        })
        modalbuttonEl.addEventListener('click', () => {
          modal.setAttribute('aria-expanded', true)
        })
        modalClose.addEventListener('click', () => {
        modal.setAttribute('aria-expanded', false)
        })
      }

      populateContentFromAjax (doc, selector) {
        const newEl = doc.querySelector(selector)
        const parentEl = getElement(selector)

        if (newEl && parentEl) {
          parentEl.replaceWith(newEl)
        }
      }

      okeReviews (){
        document.addEventListener('click', function(e) {
          if (e.target.closest('.okeReviews-reviewsSummary')) {
            e.preventDefault();
            const reviewsBlock = document.querySelector('.sec-Section-reviews'); 
            if (reviewsBlock) {
              const header = document.querySelector('header');
              const headerHeight = header ? header.offsetHeight : 0;
              const elementPosition = reviewsBlock.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - headerHeight; 
              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
              });
            }
          }
        });
      }

      setupVariantButtons() {
        const variantButtons = getElements(classes.variantButton)
        const activeClass = 'prd-ProductJourneyVariants_VariantItem-current'

        variantButtons.forEach(variantButton => {
          variantButton.addEventListener('click', event => {
            event.preventDefault();
            if (variantButton.classList.contains(activeClass)) {
              return
            }

            const variantItemsContainer = variantButton.closest(
              '.prd-ProductJourneyVariants_VariantItems',
            )

            const activeElement = variantItemsContainer.querySelector(`.${activeClass}`)
            if (activeElement) {
              activeElement.classList.remove(activeClass)
            }

            variantButton.classList.add(activeClass)

            const variantHandle = variantButton.dataset.variantHandle
            if (!variantHandle) {
              this.selectVariant(variantButton)
              return
            }

            this.loadProductIntoSection(variantHandle, true)
          })
          this.checkVariantAvailability(variantButton)
        })
      }

      async checkVariantAvailability (variantButton) {
        const variantHandle = variantButton.dataset.variantHandle
        let productdata
        try {
          productdata = await fetchProductData(variantHandle)
        } catch (e) {
          variantButton.remove();
          const variantSwatch = variantButton.dataset.variantSwatch
          if(document.querySelector(`.drw-Swatches_Item[data-handle="${variantSwatch}"]`) != null) document.querySelector(`.drw-Swatches_Item[data-handle="${variantSwatch}"]`).remove();
          return
        }
        if (!productdata) {
          variantButton.remove();
          const variantSwatch = variantButton.dataset.variantSwatch
          if(document.querySelector(`.drw-Swatches_Item[data-handle="${variantSwatch}"]`) != null) document.querySelector(`.drw-Swatches_Item[data-handle="${variantSwatch}"]`).remove();
        }
      }

      selectVariant (variantButton) {
        let i = 0

        while (i < 3) {
          const option = variantButton.dataset[`option${i + 1}`]
          const select = getElement(`${classes.singleOptionSelect}-${i}`)

          if (select) {
            select.value = option
            select.dispatchEvent(new Event('change'))
          }
          i++
        }
      }

      async loadProductIntoSection (variantHandle, pushState) {
        const errors = getElements('.prd-ProductJourneyVariants_Error')
        if (errors.length) errors.forEach(error => error.remove())

        if (!variantHandle) {
          this.addVariantError('Sorry, there was a problem loading this product')
          return
        }

        const loader = getElement(classes.loader)
        loader.classList.add('prd-Product_Loader-start')

        let productData
        try {
          productData = await fetchProductData(variantHandle)
        } catch (e) {
          loader.classList.remove('prd-Product_Loader-start')
          this.addVariantError('Sorry, there was a problem loading this product')
          return
        }

        if (!productData) {
          loader.classList.remove('prd-Product_Loader-start')
          this.addVariantError('Sorry, there was a problem loading this product')
          return
        }

        await fetch(`/products/${variantHandle}`)
          .then(res => res.text())
          .then(async html => {
            loader.classList.remove('prd-Product_Loader-start')

            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            this.populateContentFromAjax(doc, '.prd-prdBred')
            this.populateContentFromAjax(doc, '.product__media-wrapper')
            this.populateContentFromAjax(doc, '.product__info-wrapper')
            this.populateContentFromAjax(doc, '.section-Product_details')
            this.populateContentFromAjax(doc, '.section-Product-feature_img_video')
            this.populateContentFromAjax(doc, '.section-Product-danetti_quote')
            this.populateContentFromAjax(doc, '.section-product_recommendations')
            this.populateContentFromAjax(doc, '.section-Product_swatches')
            this.populateContentFromAjax(doc, '.prd-FixedBar')
            this.populateContentFromAjax(doc, 'head title')
            this.populateContentFromAjax(doc, '.section-Product_Instagram')
            this.populateContentFromAjax(doc, '.sec-Section-reviews')
            this.populateContentFromAjax(doc, '.sec-pdp-Drawers[data-module="feature-accordions"]')
            this.populateContentFromAjax(doc, '.sec-pdp-Drawers[data-module="financedrawers"]')
            this.populateContentFromAjax(doc, '.sec-pdp-Drawers[data-module="drawers"]')
            this.productFixedBar()
            this.setupFinanceCalculator()
            this.initialiseDetailsDrawer()
            this.okeReviews()

            if (pushState) window.history.pushState({}, null, `/products/${variantHandle}`)

            this.initialiseSwatchCards('',variantHandle)
            this.reloadIframe();
          })
          .then(() => {
            // for product_thumbnail
          })
          if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === "function") {
            window.okeWidgetApi.initAllWidgets();
          }
      }

      reloadIframe() {
        const iframe = document.querySelector('.prd-FeatureImage___video');
        if(iframe != null) iframe.src = iframe.getAttribute('data-src');
      }

      async initialiseSwatchCards(data,variantHandle) {
        try {
          let pathname = window.location.pathname;
          if(variantHandle != '' && variantHandle != null) pathname = `/products/${variantHandle}`;
          const response = await fetch(`${window.location.origin}${window.location.pathname}?section_id=${this.secSwatchDrawer}`);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
      
          const newDrawer = html.querySelector('.sec-Product-swatches-drawer');
          const currentDrawer = document.querySelector('.sec-Product-swatches-drawer');
          if(data != 'updateDrawer'){
            if (newDrawer && currentDrawer) {
              const modalTextEl = currentDrawer.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
              const preservedModalHtml = modalTextEl ? modalTextEl.innerHTML : null;
              const headerTitle = currentDrawer.querySelector('.drw-Header .title_section');
              const preservedTitleHtml = headerTitle ? headerTitle.innerHTML : null;
              currentDrawer.replaceWith(newDrawer);
              if (preservedModalHtml) {
                const newModalTextEl = document.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
                if (newModalTextEl) newModalTextEl.innerHTML = preservedModalHtml;
              }
              if (preservedTitleHtml) {
                const newHeaderTitle = document.querySelector('.sec-Product-swatches-drawer .drw-Header .title_section');
                if (newHeaderTitle) newHeaderTitle.innerHTML = preservedTitleHtml;
              }
            }
          }
      
          // Wait a tick to ensure new DOM is rendered
          await new Promise((resolve) => setTimeout(resolve, 0));
      
          // Re-initialize everything after drawer is swapped
          if(data != 'updateDrawer') this.initialiseDrawer();
      
          this.attachOutOfStockModalHandlers();
          this.attachSwatchCardHandlers();
          this.attachSwatchCartItemHandlers();
          this.attachCartTriggerHandler();
      
          this.updateSoldOutBorders();
          this.loadVariantImages();
      
        } catch (error) {
        }
      }

      initialiseDrawer () {
        const drawer = getElement('.sec-Product-swatches-drawer [data-module="drawers"]')
        const trigger = getElements('[data-module-drawers-trigger="product-colours"]')
        const close = getElements('[data-module-drawers-close="product-colours"]')
        if (!drawer || !trigger.length) return
        trigger.forEach((el) =>
          el.addEventListener('click', () => {
            drawer.classList.add('drw-Drawers-active')
          })
        )
        close.forEach((el) =>
          el.addEventListener('click', () => {
            drawer.classList.remove('drw-Drawers-active')
          })
        )
      }

      initialiseDetailsDrawer () {
        const featureDrawer = getElement('[data-module="feature-accordions"]')
        const featureTrigger = getElements('[data-module-drawers-trigger="feature-accordions"]')
        const featureCloses = getElements('[data-module-drawers-close="feature-accordions"]')
        featureTrigger.forEach((el) => el.addEventListener('click', e => {
          const title = el.getAttribute('data-title');
          const handle = el.getAttribute('data-handle');
          featureDrawer.querySelectorAll('.drw-Drawer_Body-Inner-data').forEach((el) => el.style.display = 'none');
          featureDrawer.querySelector(`[data-module-drawer-content="${handle}"]`).style.display = 'block';
          featureDrawer.querySelector('.drw-Header .title_section').innerHTML = title;
          featureDrawer.classList.add('drw-Drawers-active');
          document.body.classList.add('overflow-hidden');
        }))
        featureCloses.forEach((el) => el.addEventListener('click', e => {
          featureDrawer.classList.remove('drw-Drawers-active');
          document.body.classList.remove('overflow-hidden');
        }))
        document.querySelectorAll('.prd-DetailAccordion_Column-image').forEach((item) => {
          const modal = item.querySelector('[data-el="feature-accordions.modal"]');
          const modalbuttonEl = item.querySelector('[data-el="feature-accordions.modalbutton"]');
          this.initialiseModals(modal,modalbuttonEl);
        });
      }
      
      attachOutOfStockModalHandlers() {
        const outofstockModal = document.querySelector('.js-Product_SwatchesOutofstock');
        const closeButton = outofstockModal?.querySelector('.js-Product_SwatchesOutofstockModalClose');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            outofstockModal.setAttribute('aria-expanded', 'false');
          });
        }
      }
      
      attachSwatchCardHandlers() {
        const swatchCards = getElements('[data-module="swatch-card"]');
        swatchCards.forEach((el) => {
          const trigger = el.querySelector('.prd-SwatchCard_Body');
          if (trigger) {
            trigger.addEventListener('click', (e) => {
              e.preventDefault();
              if (el.classList.contains('prd-SwatchCard_outofstock')) {
                const modal = document.querySelector('.js-Product_SwatchesOutofstock');
                if (modal) modal.setAttribute('aria-expanded', 'true');
              } else {
                this.setSwatchSubmit(el);
              }
            });
          }
        });
      }
      
      attachSwatchCartItemHandlers() {
        const swatchCartItems = getElements('[data-module="swatch-cart-item"]');
        swatchCartItems.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.removeSwatch(el);
          });
        });
      }
      
      attachCartTriggerHandler() {
        const cartTrigger = getElement('[data-module-drawers-trigger="cart"]');
        if (cartTrigger) {
          cartTrigger.addEventListener('click', async () => {
            const cart = getElement('cart-notification') || getElement('cart-drawer');
            const data = await getCart();
            if (cart && cart.renderContentsSwatch) {
              cart.renderContentsSwatch(data, true);
            }
          });
        }
      }
      
      updateSoldOutBorders() {
        const imageContainers = this.querySelectorAll('.prd-ProductJourneyVariants_VariantItems .prd-Colours_Item[disabled]');
        imageContainers.forEach(item => {
          const image = item.querySelector('img');
          if (image) {
            const img = new Image();
            img.src = image.src;
            img.onload = () => {
              const dominantColor = getDominantColor(img);
              const borderColor = isDarkColor(dominantColor) ? '#fff' : '#6B6B6B';
              item.style.setProperty('--sold-borderColor', borderColor);
            };
          }
        });
      }
      
      loadVariantImages() {
        const processedSwatches = new Set();
        const failedSwatches = new Set();
        const parent = document.querySelector('.product__info-wrapper .prd-Colours_Items');
        const elements = document.querySelectorAll('.product__info-wrapper .prd-Colours_Items .prd-Colours_Item');
      
        if (!parent || parent.dataset.imageFix === "true") return;
      
        const urlsToFetch = [];
      
        elements.forEach(element => {
          const swatch = element.dataset.variantSwatch;
          if (!swatch || processedSwatches.has(swatch) || failedSwatches.has(swatch) || element.dataset.imageChecked === "true") return;
          urlsToFetch.push({ swatch, url: `/products/${swatch}.js`, element });
          processedSwatches.add(swatch);
        });
      
        if (urlsToFetch.length === 0) {
          parent.dataset.imageFix = "true";
          return;
        }
      
        Promise.all(
          urlsToFetch.map(async ({ swatch, url, element }) => {
            try {
              const response = await fetch(url);
              if (!response.ok) throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
              const data = await response.json();
              return { data, element };
            } catch (error) {
              failedSwatches.add(swatch);
              return { data: null, element };
            }
          })
        ).then(results => {
          let failedCount = 0;
          results.forEach(({ data, element }) => {
            element.dataset.imageChecked = "true"; // Mark as handled
            if (data?.featured_image) {
              const imgUrl = data.featured_image.replace(/\?.*$/, '') + '?width=110&height=110&crop=center';
              element.querySelectorAll('img').forEach(img => {
                img.src = imgUrl;
              });
            } else {
              failedCount++;
            }
          });
      
          parent.dataset.imageFix = "true"; // Prevent future runs
        });
      }                       

      setUpsellproduct(){
        const complementaryEle = document.querySelector('#complementaryProducts');
        if(complementaryEle != null && complementaryEle != undefined){
          const elementId = complementaryEle.dataset.graphenehcId || 'you_may_also_like';
          graphenehc.load({
            elements: [{ id: elementId, target: "#complementaryProducts" }],
            init : function() {},
            success : function (response) {
              if(response.elements[elementId].product_count != 0){
                setTimeout(() => {
                  const eleSlider =  complementaryEle.querySelector('[data-acs-pcp]');
                  const flkty = new Flickity( eleSlider, {"cellAlign": "left", "groupCells": true, "pageDots": false, "freeScroll": false});
                  flkty.resize();
                }, 300);
                document.querySelector('.complementary-products').style.display = 'block';
              }else{
                document.querySelector('.complementary-products').style.display = 'none';
              }
            }
          });
        }
      }

      async setSwatchSubmit (el) {
        let loading = false;

        if (loading) return false

        const form = getElement('form', { context: el })
        const formData = new FormData(form)
        const id = Number(formData.get('id'))
        const quantity = Number(formData.get('quantity'))
        const key = formData.get('key')
        const url = formData.get('url')
        const properties = buildProperties(formData)
        const swatchCount = await this.swatchCount()
        const item = {id: id,quantity: quantity,properties: properties}

        if (swatchCount > 3 && !key) {
          getElement('.drw-Swatches_Error').style.display = 'flex'
          return false
        }

        loading = true
        el.closest('.drw-Swatches').classList.add('drw-Swatches-loading')

        key ? await removeLineItem(key,url,0) : await addItemToCartSwatch(item);

        await fetch(`${window.location.href}${window.location.search ? '&' : '?'}section_id=${this.secSwatchDrawer}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const newEl = doc.querySelector('.drw-Swatches')
          const parentEl = getElement('.drw-Swatches')

          if (newEl && parentEl) {
            const modalTextEl = parentEl.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
            const preservedModalHtml = modalTextEl ? modalTextEl.innerHTML : null;
            parentEl.replaceWith(newEl);
            if (preservedModalHtml) {
              const newModalTextEl = document.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
              if (newModalTextEl) newModalTextEl.innerHTML = preservedModalHtml;
            }
          }

          el.closest('.drw-Swatches').remove('drw-Swatches-loading')
          this.initialiseSwatchCards('updateDrawer')
          loading = false
        })
      }

      async removeSwatch (el) {
        let loading = false;

        if (loading) return false

        loading = true
        el.closest('.drw-Swatches').classList.add('drw-Swatches-loading')

        const key = el.getAttribute('data-key');
        const url = el.getAttribute('data-url');

        await removeLineItem(key, url, 0)

        await fetch(`${window.location.href}${window.location.search ? '&' : '?'}section_id=${this.secSwatchDrawer}`)
        .then(res => res.text())
        .then(async html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')

          const newEl = doc.querySelector('.drw-Swatches')
          const parentEl = getElement('.drw-Swatches')

          if (newEl && parentEl) {
            const modalTextEl = parentEl.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
            const preservedModalHtml = modalTextEl ? modalTextEl.innerHTML : null;
            parentEl.replaceWith(newEl);
            if (preservedModalHtml) {
              const newModalTextEl = document.querySelector('.js-Product_SwatchesOutofstock .mod-Modal_Text');
              if (newModalTextEl) newModalTextEl.innerHTML = preservedModalHtml;
            }
          }

          el.closest('.drw-Swatches').remove('drw-Swatches-loading')
          this.initialiseSwatchCards('updateDrawer')
          loading = false
        })
      }

      async swatchCount () {
        const cart = await getCart()
        const swatches = cart.items.filter(item => item.product_type === 'Swatch')
        return swatches.length
      }

      productFixedBar(){
        window.onscroll = function() {
          const fixedBar = getElement("[data-product-fixed-bar-visibility-indicator]");
          const sticky = fixedBar.offsetTop + 400;
          window.pageYOffset > sticky ? fixedBar.classList.add("prd-FixedBar-visible"):fixedBar.classList.remove("prd-FixedBar-visible");
        };
        const scrollTrigger = getElement(`[data-el="scroll-to.trigger"]`);
        const clickTrigger = getElement(`.js-AddToCart_Submit`);
        if(scrollTrigger) scrollTrigger.addEventListener('click', event => getElement(".product__info-container").scrollIntoView());
        if (clickTrigger != null) clickTrigger.addEventListener('click', event => getElement(".product-form__submit").click());
      }

      async setupDeliveryMessage (variantHandle, data) {
        const deliveryMessage = getElement(classes.delivery)
        const deliveryMessageShort = getElement(classes.deliveryShort)

        if (!deliveryMessage) {
          if (deliveryMessageShort) {
            deliveryMessageShort.innerHTML = 'Sold out'
          }
          return
        }
        if(data == false) data = await fetchProductData(variantHandle)
        const  productMaxQuantities = await getProductMaxQuantity(`/products/${variantHandle}`);
        const quantity = getElement('[data-el="quantity-adjuster.input"]')?.value || 1
        const key = getElement('.price-per-item__container quantity-input')?.getAttribute('data-id') || null; // if element not exist then set as null (NS)
        let finalQuantity = parseInt(quantity) + (key ? parseInt(productMaxQuantities[key].cart) : 0); // if key is null then set qty as zero (NS)
        if(productMaxQuantities[key] != undefined && productMaxQuantities[key].totalAvailable <= finalQuantity || productMaxQuantities[key] != undefined && finalQuantity > productMaxQuantities[key].totalAvailable) finalQuantity = productMaxQuantities[key].totalAvailable;
        const leadTime = getProductLeadTime(data.metafields, finalQuantity)
        const leadTimeMessage = parseLeadTime(leadTime)
        let messageText = leadTimeMessage.longMessage
        let messageTextShort = leadTimeMessage.shortMessage
        deliveryMessage.innerHTML = messageText
        if (typeof window.updateDeliveryTooltipMonth === 'function') {
          window.updateDeliveryTooltipMonth(deliveryMessage, leadTimeMessage)
        }
        if (typeof window.syncDeliveryLeadTimeUI === 'function') {
          window.syncDeliveryLeadTimeUI(deliveryMessage, leadTimeMessage)
        }
        if (deliveryMessageShort) {
          deliveryMessageShort.innerHTML = messageTextShort
        }

      }

      async populateProductMedia (zoomSectionId,productHandle) {
        const path = window.location.pathname === '/products_preview'
          ? `${window.location.pathname}${window.location.search}&sections=${zoomSectionId}` : `/products/${productHandle}?sections=${zoomSectionId}`

        const productMediaHtml = await fetchJSON(`${path}`)
        const zoomCarousel = getElement('.prd-Product_ImageZoom')

        zoomCarousel.innerHTML = productMediaHtml[zoomSectionId]

        if (!customElements.get('image-zoom')) {
          customElements.define('image-zoom', imageZoom);
        }else{
          const zoomElement = getElement('image-zoom');
          zoomElement.reload();
        }
      }

      initialiseAdditionalDetails () {
        const quantityModal = getElement(classes.QuantityInfoModal)
        if(quantityModal != null){
          const quantityModalOpen = getElement(classes.QuantityInfo)
          const quantityModalClose = getElements(classes.QuantityInfoModalClose)
          quantityModalOpen && quantityModalOpen.addEventListener('click', () => {
            quantityModal.setAttribute('aria-expanded', true)
            document.body.classList.add('overflow-hidden');
          })
          quantityModalClose.forEach(el => {
            el.addEventListener('click', () => {
              quantityModal.setAttribute('aria-expanded', false)
              document.body.classList.remove('overflow-hidden');
            })
          })
        }
        getElements('.prd-section-faq-description').forEach(el => {
          el.querySelector('[data-el="un-truncate.triggerOpen"]') && el.querySelector('[data-el="un-truncate.triggerOpen"]').addEventListener('click', (event) => {
            el.querySelector('[data-el="un-truncate.content"]').style.display = 'none';
            el.querySelector('[data-el="un-truncate.fullContent"]').style.display = 'block';
          });
          el.querySelector('[data-el="un-truncate.triggerClose"]') && el.querySelector('[data-el="un-truncate.triggerClose"]').addEventListener('click', (event) => {
            el.querySelector('[data-el="un-truncate.content"]').style.display = 'block';
            el.querySelector('[data-el="un-truncate.fullContent"]').style.display = 'none';
          });
        });

        const bedsMattressesModalOpen = getElement('.prd-ProductContent_ActionButton-bedsMattresses')
        if(bedsMattressesModalOpen != null){
          const bedsMattressesModal = getElement('.js-Product_bedsMattressesfoModal')
          const bedsMattressesModalClose = getElements('.js-Product_bedsMattresseModalClose')
          bedsMattressesModalOpen && bedsMattressesModalOpen.addEventListener('click', () => {
            bedsMattressesModal.setAttribute('aria-expanded', true);
            document.body.classList.add('overflow-hidden');
          })
          bedsMattressesModalClose.forEach(el => {
              el.addEventListener('click', () => {
              bedsMattressesModal.setAttribute('aria-expanded', false);
              document.body.classList.remove('overflow-hidden');
            })
          })
        }

        const complementaryModalOpen = getElement('.complementary-products-model-button')
        if(complementaryModalOpen != null){
          const complementaryModal = getElement('.js-Product_complementaryProductsModal')
          const complementaryModalClose = getElements('.js-Product_complementaryProductsModalClose')
          complementaryModalOpen && complementaryModalOpen.addEventListener('click', () => {
            complementaryModal.setAttribute('aria-expanded', true);
            document.body.classList.add('overflow-hidden');
          })
          complementaryModalClose.forEach(el => {
              el.addEventListener('click', () => {
              complementaryModal.setAttribute('aria-expanded', false);
              document.body.classList.remove('overflow-hidden');
            })
          })
        }

      }

      setupMattressDisposal() {
        const productInfo = getElement(classes.productInfo);
        const disposalInfoTrigger = getElement(classes.disposalInfoTrigger,{ context: productInfo });
        if (disposalInfoTrigger == null) return
        const form = getElement(classes.form);
        const fixedBar = getElement(classes.fixedBar);
        const price = getElement(classes.price,{ context: productInfo });
        const priceCompareElements = getElements(classes.priceCompare);
        disposalInfoTrigger.addEventListener('change', e => {
          const checked = e.target.checked;
          const disposalPrice = parseFloat(e.target.getAttribute('data-price')) || 0;
          const productPrice = parseFloat(price.getAttribute('data-price')) || 0;
          const totalPrice = productPrice + disposalPrice;
          const dataId = e.target.getAttribute('data-id');

          form.parentNode.classList.toggle('multiple', checked);

          const additionalServicesInput = form.querySelector('input[name="properties[_additional_services]"]');
          additionalServicesInput.value = checked ? productInfo.querySelector('input[name="disposalProductId"]').value : '';
          checked ? additionalServicesInput.setAttribute('data-id', dataId) : additionalServicesInput.setAttribute('data-id', '');

          const formatPrice = amount => Shopify.formatMoney(amount);
          price.innerHTML = formatPrice(checked ? totalPrice : productPrice);
          fixedBar.querySelector(classes.price).innerHTML = formatPrice(checked ? totalPrice : productPrice);

          priceCompareElements.forEach(el => {
            const comparePrice = parseFloat(el.getAttribute('data-price')) || 0;
            el.innerHTML = formatPrice(checked ? comparePrice + disposalPrice : comparePrice);
          });
        });

        const disposalPopup = productInfo.querySelector('.js-Cart_mattressDisposalInfo');
        if (disposalPopup) {
          const disposalModal = document.body.querySelector(classes.mattressDisposalModal);
          const disposalModalClose = document.body.querySelector(classes.mattressDisposalModalClose);

          if (disposalModal && disposalModalClose) {
            disposalPopup.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'true'));
            disposalModalClose.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'false'));
          }
        }
      }

      setCheckRadio() {
        const giftCardForm = document.querySelector('.gift-card-fields');
        const radios = document.querySelectorAll('.gift-card-radio input[type="radio"]');
        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            const checkedValue = document.querySelector('.gift-card-radio input[type="radio"]:checked').value;
            checkedValue === 'true' ? giftCardForm.style = 'height:max-content' : giftCardForm.style = 'height:0';
          });
        });
      }

      setupFinanceCalculator(){
        const drawer = getElement('[data-module="financedrawers"]')
        const trigger = getElements('[data-module-drawers-trigger="finance-calculator"]')
        const close = getElements('[data-module-drawers-close="finance-calculator"]')
        trigger.forEach((el) => el.addEventListener('click', e => drawer.classList.add('drw-Drawers-active')))
        close.forEach((el) => el.addEventListener('click', e => drawer.classList.remove('drw-Drawers-active')))
        if (typeof V12 !== 'undefined') {
          if (typeof AeroEvents !== 'undefined') {
            AeroEvents.on('product.loaded', this.loadv12());
          } else {
            this.loadv12();
          }
        }
      }
    
      loadv12() {
        this.GetProducts()
        this.updateCalculator()
      }
      
      updateCalculator() {
        let _this = this;
        this.CalculateRepayments();
        let financeProductsList = document.getElementById('finance_productsList');
        financeProductsList.addEventListener('change', function () {
          _this.CalculateRepayments();
        });
    
        document.getElementById('cpRange').addEventListener("input", function () {
          _this.UpdateLoanInfo();
        });
        document.getElementById('depRange').addEventListener("input", function () {
          _this.UpdateLoanInfo();
        });
      
        document.getElementById('lowestMonthlyPayments').addEventListener('click', function () {
          const options = financeProductsList.options;
          const lastOption = options[options.length - 1].value;
          financeProductsList.value = lastOption;
          financeProductsList.dispatchEvent(new Event('change'));
        });
      
        document.getElementById('cashPrice').addEventListener('keyup', function () {
          let cp = document.getElementById('cashPrice').value;
          let dep = document.getElementById('deposit').value;
          document.getElementById('cpRange').value = cp;
          document.getElementById('depRange').value = dep;
          _this.CalculateRepayments();
        });

        document.getElementById('deposit').addEventListener('keyup', function () {
          let cp = document.getElementById('cashPrice').value;
          let dep = document.getElementById('deposit').value;
          document.getElementById('cpRange').value = cp;
          document.getElementById('depRange').value = dep;
          _this.CalculateRepayments();
        });
      }

      GetProducts() {
        let price = document.querySelector('.js-Product_Price').innerText;
        let number = Number(price.replace("£", "").replace(",", ""));
        document.querySelector("#cashPrice").value = number;
    
        let preOwnedTag = null;
        let classicFinance = null;
        let financeTermsRestricted = '1';
        let products = V12.getFinanceProducts();
        let ddlProducts = document.getElementById('finance_productsList');
        ddlProducts.innerHTML = ``;
        for (let product of products) {
          if (product.productId === 44 || product.productId === 45 || product.productId === 88 || product.productId === 124 || product.productId === 56){
          if (product.name.includes("Classic")) {
            let months = Number(product.name.match(/\d+/)[0]);
            let newItem = new Option(product.name, `${product.productId}|${product.productGuid}`);
            newItem.setAttribute('months', months);
            ddlProducts.appendChild(newItem);
          } else if (product.name.includes("Interest Free")) {
            let months = Number(product.name.match(/\d+/)[0]);
            let newItem = new Option(product.name, `${product.productId}|${product.productGuid}`);
            newItem.setAttribute('months', months);
            ddlProducts.appendChild(newItem);
          }
        }
        }
      }
      
      CalculateRepayments() {
        let productId = document.querySelector('#finance_productsList').value.split('|')[0];
        let financeProduct = V12.getFinanceProduct(productId);
        let cashPrice = document.querySelector('#cashPrice').value;
        let depositFactor = document.querySelector('#deposit').value;
        let deposit = parseFloat((Math.ceil(cashPrice * depositFactor) / 100).toFixed(2));
        let payments = V12.calculate(financeProduct, cashPrice, deposit);
        this.PopulateDescription(payments);
        const minValueUpdateEle = document.querySelector('.drw-financeCalculator-text-value');
        if(productId==='44'||productId==='45'||productId==='88'){
          minValueUpdateEle.innerHTML = '£1000';
        }else if(productId==='124'){
          minValueUpdateEle.innerHTML = '£2500';
        }else if(productId==='56'){
          minValueUpdateEle.innerHTML = '£3000';
        }else{
          const defaultValue = minValueUpdateEle.getAttribute('data-default');
          minValueUpdateEle.innerHTML = defaultValue;
        }
      }
      
      UpdateLoanInfo() {
        document.querySelector('#deposit').value = document.querySelector('#depRange').value;
        this.CalculateRepayments();
      }
      
      SelectFirstAvailable() {
        let firstVal = document.querySelector('#finance_productsList').options[0].value.split('|')[0];
        document.querySelector('#finance_productsList').value = firstVal;
      }
      
      PopulateDescription(payments) {
        document.querySelector('#vf-PurchasePrice').innerHTML = '&pound;' + payments.cashPrice;
        document.querySelector('#vf-CashPrice').innerHTML = '&pound;' + payments.amountPayable;
        let vf_Deposit = document.querySelector('#vf-Deposit');
        if (payments.deposit) {
          vf_Deposit.innerHTML = '&pound;' + payments.deposit;
          vf_Deposit.style.display = "";
          document.querySelector('#vf-DepositPercentage').innerHTML = document.querySelector('#deposit').value + '&percnt;';
        } else {
          vf_Deposit.style.display = "none";
        }
      
        document.querySelector('#vf-AmountCredit').innerHTML = '&pound;' + payments.loanAmount;
      
        let repayableText = payments.monthsDeferred > 0 
          ? 'Non-payment period ' + payments.monthsDeferred + ' months, followed by '
          : 'Repayable by ';
    
        if (payments.initialPayments !== payments.finalPayment && payments.finalPayment > 0) {
          document.querySelector('#vf-RepayableMonths').innerHTML = payments.months - 1;
          document.querySelector('#vf-FinalPayment').innerHTML = '&pound;' + payments.finalPayment;
          document.querySelector('#row-vf-FinalPayment').style.display = "";
        } else {
          document.querySelector('#vf-RepayableMonths').innerHTML = payments.months;
          document.querySelector('#row-vf-FinalPayment').style.display = "none";
        }
    
        document.querySelector('#vf-Repayable').innerHTML = '&pound;' + payments.initialPayments;
        document.querySelector('#vf-Apr').innerHTML = payments.apr + '%';
        document.querySelector('#vf-AnnualRate').innerHTML = payments.annualRate + '%';
      
        let vf_ArrangementFee = document.querySelector('#vf-ArrangementFee');
        if (payments.documentFee > 0) {
          vf_ArrangementFee.innerHTML = 'Arrangement fee &pound;' + payments.documentFee + '.';
          vf_ArrangementFee.style.display = "";
        } else {
          vf_ArrangementFee.style.display = "none";
        }
    
        let vf_SettlementFee = document.querySelector('#vf-SettlementFee');
        if (payments.settlementFee > 0) {
          vf_SettlementFee.innerHTML = 'Settlement fee &pound;' + payments.settlementFee + '.';
          vf_SettlementFee.style.display = "";
        } else {
          vf_SettlementFee.style.display = "none";
        }
      
        document.querySelector('#vf-TotalRepayable').innerHTML = 'Total amount repayable &pound;' + payments.amountPayable + ' including total interest of &pound;' + payments.interest + '.';
        document.querySelector('#vf-Interest').innerHTML = '&pound;' + payments.interest;
    
        let vf_Bnpl = document.querySelector('#vf-Bnpl');
        if (payments.monthsDeferred > 0 && payments.name.includes('Buy Now Pay Later')) {
          vf_Bnpl.innerHTML = 'Buy Now Pay Later Option: If you pay the amount of credit plus the settlement fee of &pound;' + payments.settlementFee +
            ' by the end of the non-payment period, you will pay no interest. If you have not paid the amount of credit in full before the end of the non-payment period the &pound;' + payments.settlementFee + ' fee will not be payable but interest (at the rate specified above) will be charged on the outstanding credit amount, from the date we told you your agreement was live.';
          vf_Bnpl.style.display = "";
        } else {
          vf_Bnpl.style.display = "none";
        }
      }
      
      GetLowestMonthlyPayments(event) {
        let preOwnedTag = null;
        let classicFinance = null;
        let financeTermsRestricted = '1';
    
        let products = V12.getFinanceProducts();
        if (preOwnedTag || classicFinance) {
          products = products.filter(obj => obj.name.includes("Classic"));
        }
    
        let lowestMonthlyPayment = Infinity;
        let lowestMonthlyPaymentProductId = null;
      
        for (let product of products) {
          let productDetails = V12.getFinanceProduct(product.productId);
          var cashPrice = document.querySelector('#cashPrice').value;
          let depositFactor = document.querySelector('#deposit').value;
          let deposit = parseFloat((Math.ceil(cashPrice * depositFactor) / 100).toFixed(2));
          let payments = V12.calculate(productDetails, cashPrice, deposit);
          let monthlyPayment = payments.initialPayments;
  
          if (monthlyPayment < lowestMonthlyPayment) {
            lowestMonthlyPayment = monthlyPayment;
            let productName = productDetails.name;

            if (cashPrice <= 899 && productName.includes('Classic')) {
              lowestMonthlyPaymentProductId = `${productDetails.productId}|${productDetails.productGuid}`;
            } else if (cashPrice >= 900 && cashPrice <= 25000 && productName.includes('Interest Free')) {
              lowestMonthlyPaymentProductId = `${productDetails.productId}|${productDetails.productGuid}`;
            }
          }
        }
        document.querySelector("#finance_productsList").value = lowestMonthlyPaymentProductId;
        this.CalculateRepayments();
      }

      initialiesGaEvents(name){
        const eventMappings = [
          { selector: '.prd-ProductContent_Reviews', action: 'PDP Reviews' },
          { selector: '.prd-Wishlist_Button', action: 'PDP Wishlist' },
          { selector: '.prd-ProductContent_ActionButton-calculator', action: 'PDP Finance', label: 'Calculator' },
          { selector: '.prd-ProductContent_ActionButton-swatches', action: 'PDP Requests swatch 1' },
          { selector: '.sec-Product-swatches .swatches', action: 'PDP Requests swatch 2' },
          { selector: '#okeReviews-reviews-controls-sort', action: 'PDP Review section', label: 'Filters' },
          { selector: '.okeReviews-reviews-showMore', action: 'PDP Review section', label: 'Show more button' },
          { selector: '.sec-Product-instagram .sec-Instagram', action: 'PDP foursixty block', label: 'Instagram' },
        ];
        const eventMappingsSecond = [
          { selector: '.prd-ProductOffers_Klarna', action: 'PDP Finance', label: 'Klarna' },
          { selector: '.okeReviews-qandaWidget-header-controls-askQuestion', action: 'PDP Questions', label: 'Ask a question' },
          { selector: '#okeReviews-qandaWidget-controls-sort', action: 'PDP Questions', label: 'Filters' },
          { selector: '.okeReviews-qandaWidget-showMore', action: 'PDP Questions', label: 'Show more button' },
        ];
        eventMappings.forEach(({ selector, action, label }) => {
          const element = getElement(selector);
          if (element) {
            addEventAndObserve(element, 'click', (e) => {
              e.preventDefault();
              setPdpPromotion(name, action, label || '');
              return false;
            },false);
          }
        }); 
        addEventAndObserve(getElement('.prd-ProductOffers_Finance'), 'click', (e) => {
          setPdpPromotion(name, 'PDP Finance', 'V12' || '');
          return false;
        },false);
        setTimeout(() => {
          eventMappingsSecond.forEach(({ selector, action, label }) => {
          const element = getElement(selector);
          if (element) {
            addEventAndObserve(element, 'click', (e) => {
              setPdpPromotion(name, action, label || '');
              return false;
            },false);
          }
        }); 
        }, 2500);
        getElements('.prd-DetailAccordion_Items .accordion').forEach(el => {
          const accordionTitle = el.querySelector('.accordion__title').innerText;
          addEventAndObserve(el, 'click', () => {
            setPdpPromotion(name, 'PDP Accordions', accordionTitle);
          },false);
        });
      
        getElements('.GalleryThumbnail .thumbnail-list__item').forEach(el => {
          addEventAndObserve(el, 'click', () => {
            setPdpPromotion(name, 'PDP image thumbnails', '');
          },false);
        });
      
        getElements('.bdc-Breadcrumb_Items .bdc-Breadcrumb_Link').forEach(el => {
          const label = el.querySelector('span[itemprop="name"]').innerText;
          addEventAndObserve(el, 'click', () => {
            setPdpPromotion(name, 'PDP breadcrumbs', label);
          },false);
        });
      
        getElements('.prd-ProductOffers_NewOption').forEach(el => {
          const optionName = el.querySelector('.prd-ProductOffers_NewOptionLabel').innerText;
          el.querySelectorAll('.js-Product_VariantButton').forEach(subEl => {
            addEventAndObserve(subEl, 'click', () => {
              const label = el.querySelector('p').innerText;
              setPdpPromotion(name, `PDP ${optionName.split(':')[0]}`, label);
            },false);
          });
        });
      }
    }
  );
}